import { useTranslation } from 'react-i18next'
import { BackArrowIcon, BaseError } from '../BaseError'

export function CampaignIsArchived({
	campaignId,
	companyId,
}: {
	campaignId: string
	companyId: string
}) {
	const { t } = useTranslation('common')

	return (
		<BaseError
			errorCode={423}
			heading={t('errors.campaignArchived.heading')}
			message={
				<>
					<span>{t('errors.campaignArchived.message')}</span>
					<br />
					<span className="text-sm text-grey-500">
						{t('errors.campaignArchived.campaignId', { id: campaignId })}
					</span>
				</>
			}
			suggestions={[t('errors.campaignArchived.suggestion')]}
			actions={[
				{
					label: t('errors.campaignArchived.backToDashboard'),
					ariaLabel: t('errors.campaignArchived.backToDashboard'),
					to: `/company/${companyId}`,
					icon: <BackArrowIcon />,
				},
			]}
		/>
	)
}
